import * as PIXI from "pixi.js";
import {Assets} from "pixi.js";
import {app, bgSound, events, gameData, iconSizes} from "../../utils/pixiApp";
import {getDeviceMedia} from "../../utils/sizes";

const soundButtons = {
    on: {
        default: 'onDefault',
        disabled: 'onDisabled',
        hover: 'onHover',
        pressed: 'onPressed'
    },
    off: {
        default: 'offDefault',
        disabled: 'offDisabled',
        hover: 'offHover',
        pressed: 'offPressed'
    },
    getItem(isActive) { return isActive ? this.on : this.off }
}

export class Sound extends PIXI.Container {
    img;
    actionState = 'default';

    constructor(heightContainer) {
        super();
        this.mediaScreen = getDeviceMedia(app.screen.width)
        this.defaultImg = new PIXI.Sprite(Assets.get(soundButtons.getItem(true).default));

        this.img = this.defaultImg;
        this.img.setSize(iconSizes[this.mediaScreen].soundIcon.size, iconSizes[this.mediaScreen].soundIcon.size)
        this.img.anchor.set(0, 0.5);
        this.img.position.x = iconSizes[this.mediaScreen].soundIcon.positionLeft ;
        this.img.position.y = heightContainer / 2;
        this.img.eventMode = 'static';
        this.img.cursor = 'pointer'
        this.img.on("pointerdown", this.onClick.bind(this));
        this.img.on("pointerover", this.onHover.bind(this));
        this.img.on("pointerout", this.onLeave.bind(this));
        this.addChild(this.img);

        this.soundIsActive = gameData.getGameData('sound');
        this.img.texture = Assets.get(soundButtons.getItem(this.soundIsActive)[this.actionState]);

        events.onSoundEvent(this.onSoundHandler.bind(this))

        events.onScreenResizeEvent(() => {
            this.resizeView();
        })
    }

    onClick() {
        events.emitSoundEvent(!this.soundIsActive);
        if(!this.soundIsActive) {
            bgSound.pause()
        } else {
            bgSound.play()
        }
    }

    onHover() {
        this.actionState = 'hover'
        const currentTexture = soundButtons.getItem(this.soundIsActive).hover;
        this.img.texture = Assets.get(currentTexture);
    }

    onLeave() {
        this.actionState = 'default'
        const currentTexture = soundButtons.getItem(this.soundIsActive).default;
        this.img.texture = Assets.get(currentTexture);
    }

    onSoundHandler() {
        this.soundIsActive = gameData.getGameData('sound');
        this.img.texture = Assets.get(soundButtons.getItem(this.soundIsActive)[this.actionState]);
    }

    resizeView() {
        const media = getDeviceMedia(app.screen.width)
        if(this.mediaScreen !== media) {
            this.mediaScreen = media;
            this.img.setSize(iconSizes[this.mediaScreen].soundIcon.size, iconSizes[this.mediaScreen].soundIcon.size);
            this.img.position.x = iconSizes[this.mediaScreen].soundIcon.positionLeft;
            this.img.position.y = media === 'web' ? 80 / 2 : 56 / 2
        }
    }
}